import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import PrivateRoute from "./Components/PrivateRoute";
import { PageRoutes } from "./Utils/constant";
import { ToastContainer } from "react-toastify";
import NLPSearch from "./Pages/NLPSearch";
import Setting from "./Pages/Setting";
import AddBumperVideo from "./Pages/AddBumperVideo";
import GameViewDetail from "./Pages/GameViewDetail";
import GameView from "./Pages/Home/GameView";
import AudienceLayer from "./Pages/Audience";
import { AL_URL } from "./Pages/Audience/api";

function App() {
  return (
    <>
      <Routes>
        <Route
          path={PageRoutes.Dashboard}
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.Games}
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.Game}
          element={
            <PrivateRoute>
              <GameViewDetail />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.GameViewDetail}
          element={
            <PrivateRoute>
              <GameView />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.SettingBumperVideo}
          element={
            <PrivateRoute>
              <Setting />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.SettingPersonalizedChannel}
          element={
            <PrivateRoute>
              <Setting />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.NLPSeach}
          element={
            <PrivateRoute>
              <NLPSearch />
            </PrivateRoute>
          }
        />
        <Route
          path={PageRoutes.BumperVideo}
          element={
            <PrivateRoute>
              <AddBumperVideo />
            </PrivateRoute>
          }
        />
        {/* Only in builds that know where the Audience Layer is (staging today). */}
        {AL_URL && (
          <Route
            path={PageRoutes.Audience}
            element={
              <PrivateRoute>
                <AudienceLayer />
              </PrivateRoute>
            }
          />
        )}
        <Route path={PageRoutes.Login} element={<Login />} />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
